import firebase from "firebase/compat/app";
import { getFirestore, collection, getDocs } from "firebase/firestore/lite";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
//import auth from "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBfcVE-9H9T05llwKWQ6zCajyDCdP0ePiI",
  authDomain: "clone-781d0.firebaseapp.com",
  projectId: "clone-781d0",
  storageBucket: "clone-781d0.appspot.com",
  messagingSenderId: "790489318314",
  appId: "1:790489318314:web:baaceca4c309fb9a6ae1d3",
  measurementId: "G-05WJL7D7FB",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = getFirestore(firebaseApp);

const auth = getAuth();

export { db, auth, createUserWithEmailAndPassword, signInWithEmailAndPassword };
